class QuickAddDrawer extends Drawer {
  connectedCallback() {

    this.overlay = this.querySelector('#QuickAddDrawer-Overlay');
    this.closeButton = this.querySelector('.drawer__close');

    this.overlay.addEventListener('click', () => {
      if(document.querySelector('#CardDrawer free-shipping')) {
        document.querySelector('#CardDrawer free-shipping').style.zIndex = 1;
      }
      this.close()
    });
    this.closeButton.addEventListener('click', () => {
      if(document.querySelector('#CartDrawer free-shipping')) {
        document.querySelector('#CartDrawer free-shipping').style.zIndex = 1;
      }
    });

    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);

  }
}
customElements.define('quick-add-drawer', QuickAddDrawer);
